<script>
import {myPath} from "@/utils/constant";

export default {
  name: "PrintPage",
  data() {
    return {
      countDown: 10,
      timer: null,

    }
  },// end of data

  mounted() {

    const printData = this.$route.params.printData

    this.setupTimer()

    this.startPrint(printData)

  },// end of mounted

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    // String visitorName, String visitorCode,String visitorCompany, String visitorReason, String employName

    toFixShowTel(telNo) {
      if (telNo == null || telNo.length < 11) {
        return telNo
      }
      return telNo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    tofixShowIdCard(idCard) {
      if (idCard == null || idCard.length < 18) {
        return idCard
      }
      return idCard.replace(/(\d{4})\d{10}(\d{4})/, '$1****$2')
    },

    startPrint(printData) {
      if (!printData) {
        console.error("printData is null")
        return
      }
      console.log("startPrint", printData)
      const printAgs = {
        visitorName: printData.visitorName ? printData.visitorName : "",
        visitorCode: printData.visitorCode ? printData.visitorCode : "",
        visitorCompany: printData.visitorCompany ? printData.visitorCompany : "",
        visitorReason: printData.visitorReason ? printData.visitorReason : "",
        employName: printData.employName ? printData.employName : "",
        employDepartment: printData.employDepartment ? printData.employDepartment : "",
        visitorCar: printData.visitorCar ? printData.visitorCar : "",
        visitorTime: printData.visitorTime ? printData.visitorTime : "",
        visitorGoods: printData.visitorGoods ? printData.visitorGoods : "",
        idCardNo: !this.$store.getters.icHidden && printData.idCardNo ? this.tofixShowIdCard(printData.idCardNo) : "",
        visitorPhone: printData.visitorPhone ? this.toFixShowTel(printData.visitorPhone) : "",
      }

      const printDataStr = JSON.stringify(printAgs)
      if (this.PrintInfo && this.PrintInfo.printVisitorInfo) {
        this.PrintInfo.printVisitorInfo(printDataStr)
      } else {
        console.error('PrintInfo is null')
      }

      // 调用打印机打印
    },

    setupTimer() {
      this.countDown = 10
      this.timer = setInterval(() => {
        console.log("printPage countDown", this.countDown)
        this.countDown--
        if (this.countDown <= 0) {
          console.log("printPage countDown end")
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
          this.$router.push({name: myPath.home})
        }
      }, 1000)

    },

    jumpToHome() {
      console.log("jumpToHome")
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.$router.push({name: myPath.home})
    },


  },// end of methods
}
</script>

<template>
  <div class="common-page-box">
    <div class="back-btn" @click="jumpToHome">
      <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
    </div>

    <div class="page-title" style="font-size:64px;margin-top:48px">正在打印</div>

    <div class="card print-card">
      <img class="print-logo" :src="require('@/assets/logo-print.png')" alt="">
      <div class="print-title">正在打印，请取走您的访客凭证</div>
      <div class="print-countdown"><b>{{ countDown }}</b> 秒后自动返回首页</div>
    </div>
  </div>
</template>

<style scoped lang="less">
.print-card {
  margin: 56px 96px 72px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 56px;

  .print-logo {
    width: 360px;
    height: 360px;
    object-fit: contain;
  }

  .print-title {
    font-size: 44px;
    font-weight: 600;
    color: var(--ink);
    letter-spacing: 0.04em;
  }

  .print-countdown {
    font-size: 32px;
    color: var(--ink-3);

    b {
      color: var(--ink);
      font-variant-numeric: tabular-nums;
    }
  }
}
</style>
